import React, { useState, useEffect, useRef } from "react";
import EditIcon from "@mui/icons-material/Edit";
import NarrativeSummary from "./NarrativeSummary";
import DeleteIcon from "@mui/icons-material/Delete";
import NarrativeMedia from "../Media/NarrativeMedia";
import EditClCommentModal from "./EditClCommentModal";
import { useDispatch, useSelector, useStore } from "react-redux";
import { GetUTCTime } from "../../../Helpers/GetUTCTime";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { UpdateTemplateDataSpecific } from "../../../Helpers/ApiCall";
import { replacePlaceholdersWithDropdowns } from "./CommentLibraryHelper";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteCommentDialog from "../../../Common/Alert/DeleteCommentDialog";
import { cleanPayloadOnCommentICMediaLevel, cleanPayloadOnCommentLevel, cleanPayloadForCommentReorder, insertCommentAfterInDisplayOrder, cloneCommentInputControls, buildRelocatedComment, addCommentToDestination, markCommentDeleted, regenerateCommentPlaceholderIds, waitForInspectionSaveResult, cleanPayloadForCommentRelocation } from "../../../Helpers/HelperFunctions";
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import VideocamIcon from '@mui/icons-material/Videocam';
import { Box, Grid, Typography, IconButton, Accordion, AccordionSummary, AccordionDetails, useMediaQuery, Divider, Popover, ClickAwayListener, Paper, MenuItem, Menu, ListItemIcon, ListItemText } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { activateLines, updateInspectionTemplateDataOffline } from "../../../Redux/Actions/CommonActions";
import MoveCopyCommentModal from "./MoveCopyCommentModal";
import { isHTCompanyKey } from "../../../Utils/services";
import toast from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { Base64 } from "js-base64";
import { origin } from "../../../Config/Api-constants";
import { MOVE_COPY_TOAST_NAV_SOURCE } from "../../../Config/App-constants";
import DeleteMediaModal from "../../../Pages/ReportLibrary/DeleteMediaModal";
import { MdOutlineModeEditOutline, MdOutlineFolderCopy } from "react-icons/md";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import LibraryAddOutlinedIcon from "@mui/icons-material/LibraryAddOutlined";
import { MdOutlineUnfoldMore } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";

const CollapsibleComment = ({ html, children, expanded, className, style, fontSize = "16px", maxLines = 15, threshold = 15 }) => {
  const containerRef = useRef(null);
  const [shouldClamp, setShouldClamp] = useState(false);

  useEffect(() => {
    const checkHeight = () => {
      const el = containerRef.current;
      if (el) {
        // Temporarily reset clamp to measure full content height
        const prevClamp = el.style.webkitLineClamp;
        const prevDisplay = el.style.display;
        const prevBoxOrient = el.style.webkitBoxOrient;
        const prevOverflow = el.style.overflow;

        el.style.webkitLineClamp = "unset";
        el.style.display = "block";
        el.style.webkitBoxOrient = "unset";
        el.style.overflow = "visible";

        const height = el.scrollHeight;
        const computedLineHeight = parseFloat(window.getComputedStyle(el).lineHeight);
        const lineHeight = isNaN(computedLineHeight) || computedLineHeight === 0 ? 30 : computedLineHeight;

        // Restore styles
        el.style.webkitLineClamp = prevClamp;
        el.style.display = prevDisplay;
        el.style.webkitBoxOrient = prevBoxOrient;
        el.style.overflow = prevOverflow;

        const lines = Math.round(height / lineHeight);
        if (lines > threshold) {
          setShouldClamp(true);
        } else {
          setShouldClamp(false);
        }
      }
    };

    checkHeight();
    const resizeObserver = new ResizeObserver(() => {
      checkHeight();
    });
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    return () => resizeObserver.disconnect();
  }, [html, children, threshold]);

  const clampStyle = !expanded && shouldClamp ? {
    display: "-webkit-box",
    WebkitLineClamp: maxLines,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  } : {
    display: "block",
    WebkitLineClamp: "unset",
    WebkitBoxOrient: "unset",
    overflow: "visible",
  };

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        ...style,
        ...clampStyle,
        width: "100%",
        minWidth: 0,
        wordBreak: "break-word",
        overflowWrap: "break-word",
      }}
    >
      {html !== undefined && html !== null ? (
        <div
          style={{ fontSize, wordBreak: "break-word", overflowWrap: "break-word" }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      ) : (
        <div style={{ fontSize, wordBreak: "break-word", overflowWrap: "break-word" }}>{children}</div>
      )}
    </div>
  );
};

const CommentDetailsNarrative = (props) => {
  let {
    toggle,
    selectedMediaFiles,
    setSelectedImages,
    setSelectedMediaFiles,
    comment_text,
    uuid,
    comment_dropdowns = [],
    summaries,
    summary_comment_text,
    summary_comment_dropdowns = [],
    title,
    templateId,
    categoryId,
    categoryUuid,
    lineUuid,
    commentIndex,
    is_selected,
    lineData,
    comment_input_controls,
    isNarrative,
    addCommentFromLine,
    tags,
    categoryName,
    setLineData,
    is_expanded,
    dragHandleRef,
    dragListeners,
    isDragging,
    onCommentDuplicated
  } = props;

  const [commentSelected, setCommentSelected] = useState(true);
  const navigate = useNavigate();
  const [inspectionData, setInspectionData] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [showEditCLModal, setShowEditCLModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [commentTitle, setCommentTitle] = useState("");
  const [commentTag, setCommentTag] = useState([]);
  const [summaryTag, setSummaryTag] = useState([]);
  const [commentText, setCommentText] = useState({ innerHTML: "", dropdownList: [] });
  const [summaryText, setSummaryText] = useState({ innerHTML: "", dropdownList: [] });
  const [summaryDropDowns, setSummaryDropDowns] = useState("");
  const [commentDropDowns, setCommentDropDowns] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [newDropdownList, setNewDropdownList] = useState(null);
  const [selectedCommentId, setSelectedCommentId] = useState(null);
  const [openDeleteMediaModal, setOpenDeleteMediaModal] = useState(false);
  const [activeDeleteMedia, setActiveDeleteMedia] = useState(null);
  const [commentUuid, setCommentUuid] = useState("");
  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const [showMoveCopyModal, setShowMoveCopyModal] = useState(false);
  const [moveCopyMode, setMoveCopyMode] = useState("move");

  const handleOpenOptionsMenu = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setOptionsAnchorEl(event.currentTarget);
  };

  const handleCloseOptionsMenu = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
      event.preventDefault();
    }
    setOptionsAnchorEl(null);
  };

  const handleToggleExpandFromMenu = (event) => {
    handleCloseOptionsMenu(event);
    checkComment(event, !is_expanded);
  };

  const handleEditFromMenu = (event) => {
    handleCloseOptionsMenu(event);
    handleOpenEditModal(uuid);
  };

  const handleDuplicateFromMenu = async (event) => {
    handleCloseOptionsMenu(event);
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
    let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item.id === categoryId);
    let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
    if ([templateIndex, categoryIndex, lineIndex].some((idx) => idx === undefined || idx < 0)) return;

    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;
    let targetComments = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]?.comments || [];
    let targetCommentIndex = targetComments.findIndex((item) => item.uuid === uuid);
    if (targetCommentIndex === -1) return;

    const originalComment = targetComments[targetCommentIndex];
    const newCommentUuid = uuidv4();
    const utcNow = await GetUTCTime();

    const duplicatedComment = JSON.parse(JSON.stringify(originalComment));
    duplicatedComment.uuid = newCommentUuid;
    duplicatedComment.created_at = utcNow;
    duplicatedComment.updated_at = utcNow;
    duplicatedComment.is_selected_updated_at = utcNow;
    duplicatedComment.is_deleted = 0;
    duplicatedComment.is_selected = 1;
    duplicatedComment.is_expanded = 1;

    duplicatedComment.comment_input_controls = cloneCommentInputControls(duplicatedComment.comment_input_controls, utcNow);
    regenerateCommentPlaceholderIds(duplicatedComment);

    insertCommentAfterInDisplayOrder(targetComments, originalComment, duplicatedComment, utcNow);

    if (typeof setLineData === "function") {
      setLineData(prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]);
    }
    onCommentDuplicated?.(newCommentUuid);
    // Renumbering touches sibling comments' `order`, so the whole line's comment list is sent
    const filteredObject = cleanPayloadForCommentReorder(prevData, templateIndex, categoryIndex, lineIndex);
    await UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    toast.success("Comment duplicated successfully");
  };

  const cleanHtmlForCopy = (rawHtml, dropdowns) => {
    if (!rawHtml) return "";
    let html = rawHtml;
    html = html.replace(/<h2[^>]*>[\s\S]*?<\/h2>/gi, "").replace(/<button\b[^>]*>.*?<\/button>/gi, "");
    if (Array.isArray(dropdowns) && dropdowns.length > 0) {
      dropdowns.forEach((dd) => {
        const regex = new RegExp(`\\[dropdown\\s+${dd.dropdown_uuid}\\]`, "gi");
        const val = dd.selected_value ? dd.selected_value.replace(/&quot;/g, '"').trim() : "";
        html = html.replace(regex, val);
      });
    }
    html = html.replace(/\[dropdown\s+([a-f0-9-]+)\]/gi, "");
    html = html.replace(/\[textbox\s+id:([a-f0-9-]+)([^\]]*)\]/gi, (match, id, inner) => {
      const vm = inner.match(/value\s*:\s*([^;]+)/i);
      return vm ? vm[1].trim() : "";
    });
    return html.trim();
  };

  const cleanTextForCopy = (rawHtml, dropdowns) => {
    if (!rawHtml) return "";
    let text = cleanHtmlForCopy(rawHtml, dropdowns);
    text = text.replace(/<br\s*\/?>/gi, "\n").replace(/<\/p>/gi, "\n").replace(/<p[^>]*>/gi, "");
    text = text.replace(/<\/?[^>]+(>|$)/g, "");
    const txt = document.createElement("textarea");
    txt.innerHTML = text;
    text = txt.value;
    text = text.replace(/\u00A0/g, " ").replace(/&nbsp;/g, " ");
    return text.split("\n").map((l) => l.trim()).filter(Boolean).join("\n");
  };

  const copyToClipboardWithHtml = async (copiedText, copiedHtml) => {
    try {
      if (
        navigator.clipboard &&
        window.isSecureContext &&
        typeof ClipboardItem !== "undefined" &&
        typeof navigator.clipboard.write === "function"
      ) {
        const htmlBlob = new Blob([copiedHtml || copiedText], { type: "text/html" });
        const textBlob = new Blob([copiedText], { type: "text/plain" });
        const data = new ClipboardItem({
          "text/html": htmlBlob,
          "text/plain": textBlob,
        });
        await navigator.clipboard.write([data]);
      } else if (navigator.clipboard && window.isSecureContext && typeof navigator.clipboard.writeText === "function") {
        await navigator.clipboard.writeText(copiedText);
      } else {
        const listener = (e) => {
          if (copiedHtml) {
            e.clipboardData.setData("text/html", copiedHtml);
          }
          e.clipboardData.setData("text/plain", copiedText);
          e.preventDefault();
        };
        document.addEventListener("copy", listener);
        document.execCommand("copy");
        document.removeEventListener("copy", listener);
      }
      toast.success("Text copied to clipboard");
    } catch (err) {
      console.error("Failed to copy text: ", err);
      try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
          await navigator.clipboard.writeText(copiedText);
          toast.success("Text copied to clipboard");
          return;
        }
      } catch (fallbackErr) {
        console.error("Fallback copy failed: ", fallbackErr);
      }
      toast.error("Failed to copy text to clipboard");
    }
  };

  const handleCopyTextFromMenu = async (event) => {
    handleCloseOptionsMenu(event);
    const isHT = isHTCompanyKey();

    const cleanTitle = title ? cleanTextForCopy(title, comment_dropdowns) : "";
    const cleanTitleHtml = title ? `<strong>${title.trim()}</strong>` : "";

    const cleanDescription = comment_text ? cleanTextForCopy(comment_text, comment_dropdowns) : "";
    const cleanDescriptionHtml = comment_text ? cleanHtmlForCopy(comment_text, comment_dropdowns) : "";

    const cleanSummary = summary_comment_text ? cleanTextForCopy(summary_comment_text, summary_comment_dropdowns) : "";
    const cleanSummaryHtml = summary_comment_text ? cleanHtmlForCopy(summary_comment_text, summary_comment_dropdowns) : "";

    const textSections = [];
    if (cleanTitle) textSections.push(cleanTitle);
    if (cleanDescription) textSections.push(cleanDescription);
    if (isHT && cleanSummary) textSections.push(cleanSummary);
    const copiedText = textSections.join("\n\n");

    const htmlSections = [];
    if (cleanTitleHtml) htmlSections.push(`<p>${cleanTitleHtml}</p>`);
    if (cleanDescriptionHtml) {
      const trimmedDesc = cleanDescriptionHtml.trim();
      htmlSections.push(
        trimmedDesc.startsWith("<p") || trimmedDesc.startsWith("<div") ? trimmedDesc : `<p>${trimmedDesc}</p>`
      );
    }
    if (isHT && cleanSummaryHtml) {
      const trimmedSum = cleanSummaryHtml.trim();
      htmlSections.push(
        trimmedSum.startsWith("<p") || trimmedSum.startsWith("<div") ? trimmedSum : `<p>${trimmedSum}</p>`
      );
    }
    const copiedHtml = htmlSections.join("");

    await copyToClipboardWithHtml(copiedText, copiedHtml);
  };

  const handleOpenMoveModal = (event) => {
    handleCloseOptionsMenu(event);
    setMoveCopyMode("move");
    setShowMoveCopyModal(true);
  };

  const handleOpenCopyModal = (event) => {
    handleCloseOptionsMenu(event);
    setMoveCopyMode("copy");
    setShowMoveCopyModal(true);
  };

  const handleMoveOrCopyConfirm = async (destination) => {
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex(
      (item) => item.template_id === templateId
    );
    if (templateIndex === -1 || templateIndex === undefined) return;

    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;

    const sourceCatIndex = prevData.inspectiontemplates[templateIndex].categories.findIndex(
      (item) => item.id === categoryId || item.uuid === categoryUuid
    );
    if (sourceCatIndex === -1) return;

    let sourceComments = [];
    let sourceLineIndex = -1;

    if (lineUuid) {
      sourceLineIndex = prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex].lines?.findIndex(
        (line) => line.uuid === lineUuid
      );
      if (sourceLineIndex !== -1 && sourceLineIndex !== undefined) {
        sourceComments = prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex].lines[sourceLineIndex].comments || [];
      }
    } else {
      sourceComments = prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex].comments || [];
    }

    const commentIndex = sourceComments.findIndex((c) => c.uuid === uuid);
    if (commentIndex === -1) return;

    const utcNow = await GetUTCTime();

    const sourceTemplate = prevData.inspectiontemplates[templateIndex];
    const sourceComment = sourceComments[commentIndex];
    const findDestinationTemplate = (dest) =>
      prevData.inspectiontemplates.find((template) => template.template_id === (dest.templateId ?? templateId));
    const relocateTo = (dest) => {
      const destinationTemplate = findDestinationTemplate(dest);
      if (!destinationTemplate) return null;
      const relocatedComment = buildRelocatedComment(sourceComment, utcNow, { sourceTemplate, destinationTemplate });
      const placement = addCommentToDestination(destinationTemplate, dest, relocatedComment, utcNow);
      return placement ? { ...placement, template: destinationTemplate } : null;
    };
    // The success toast links to the destination, so it must only appear once the save API has responded.
    // On failure the screen is put back to the data from before the move/copy and the user is told.
    const saveRelocation = async (savingMessage, failureMessage, payload) => {
      const saveResult = waitForInspectionSaveResult(store);
      const savingToastId = toast.loading(savingMessage);
      await UpdateTemplateDataSpecific(dispatch, prevData, payload);
      const { succeeded } = await saveResult;
      toast.dismiss(savingToastId);
      if (succeeded) return true;
      dispatch(updateInspectionTemplateDataOffline(inspectionData));
      if (typeof setLineData === "function" && sourceLineIndex >= 0) {
        setLineData(inspectionData.inspectiontemplates[templateIndex].categories[sourceCatIndex].lines[sourceLineIndex]);
      }
      toast.error(failureMessage);
      return false;
    };

    if (moveCopyMode === "move") {
      const dest = Array.isArray(destination) ? destination[0] : destination;
      if (!dest) return;

      const placement = relocateTo(dest);
      if (!placement) return;

      // Soft delete original comment at source location
      markCommentDeleted(sourceComment, utcNow);

      if (typeof setLineData === "function" && sourceLineIndex >= 0) {
        setLineData(prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex].lines[sourceLineIndex]);
      }
      // Only the source line (original soft-deleted) and the destination line are sent; a comment that sits on
      // the category itself has no source line, so that rare case keeps sending the full data
      const movePayload =
        sourceLineIndex >= 0
          ? cleanPayloadForCommentRelocation(prevData, [
              {
                template: sourceTemplate,
                category: prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex],
                line: prevData.inspectiontemplates[templateIndex].categories[sourceCatIndex].lines[sourceLineIndex],
              },
              placement,
            ])
          : prevData;
      if (!(await saveRelocation("Moving comment...", "Couldn't move the comment. Please try again.", movePayload))) return;

      const { template: targetTemplate, category: targetCat, line: targetLine } = placement;
      const isNarrativeTemplate = targetTemplate?.is_narrative_template === 1;
      const catName = targetCat?.prompt !== null && targetCat?.prompt !== "" ? targetCat.prompt : (targetCat?.name || dest.categoryName || "Untitled");
      const lineName = targetLine?.prompt !== null && targetLine?.prompt !== "" ? targetLine.prompt : (targetLine?.name || dest.lineName || "");
      const destLabel = lineName ? `${catName}/${lineName}` : catName;

      toast.custom(
        (t) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "14px",
              backgroundColor: "#E6F7EC",
              border: "1px solid #A2E6C6",
              borderRadius: "10px",
              padding: "10px 16px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
              color: "#065F46",
              fontSize: "14px",
              fontFamily: '"Source Sans Pro", "Open Sans", sans-serif',
              maxWidth: "90vw",
              opacity: t.visible ? 1 : 0,
              transition: "opacity 200ms ease-in-out",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <CheckCircleIcon style={{ color: "#0B8A46", fontSize: "20px" }} />
              <span>
                Comment moved to{" "}
                <span
                  style={{ fontWeight: 700, textDecoration: "underline", cursor: "pointer", color: "#065F46" }}
                  onClick={() => {
                    toast.dismiss(t.id);
                    if (targetLine) {
                      navigate(
                        `/inspection/${encodeURIComponent(catName)}/${encodeURIComponent(lineName)}`,
                        {
                          state: {
                            line: targetLine,
                            category: targetCat,
                            category_name: catName,
                            template_id: targetTemplate.template_id,
                            category_id: targetCat.id,
                            category_uuid: targetCat.uuid,
                            line_uuid: targetLine.uuid,
                            template_guid: targetTemplate?.template_guid,
                            parent_uuid: targetCat?.parent_uuid,
                            isNarrative: isNarrativeTemplate,
                            clickedFrom: MOVE_COPY_TOAST_NAV_SOURCE,
                            target: "comment",
                          },
                        }
                      );
                      dispatch(activateLines(targetLine.uuid));
                    } else if (targetCat) {
                      navigate(
                        `/inspection/${encodeURIComponent(catName)}`,
                        {
                          state: {
                            category: targetCat,
                            category_name: catName,
                            template_id: targetTemplate.template_id,
                            category_id: targetCat.id,
                            category_uuid: targetCat.uuid,
                            parent_uuid: targetCat?.parent_uuid,
                            isNarrative: isNarrativeTemplate,
                            clickedFrom: MOVE_COPY_TOAST_NAV_SOURCE,
                          },
                        }
                      );
                    }
                  }}
                >
                  {destLabel}
                </span>
              </span>
            </div>
            <CloseIcon
              style={{ fontSize: "18px", color: "#4B5563", cursor: "pointer" }}
              onClick={() => toast.dismiss(t.id)}
            />
          </div>
        ),
        {
          position: "top-center",
          duration: 8000,
        }
      );
    } else {
      // COPY MODE (multi selection)
      const destList = Array.isArray(destination) ? destination : [destination];
      if (destList.length === 0) return;

      const placements = destList.map((dest) => ({ dest, placement: relocateTo(dest) })).filter(({ placement }) => placement);
      if (placements.length === 0) return;

      // The source line is unchanged by a copy, so only the destination lines are sent
      const copyPayload = cleanPayloadForCommentRelocation(prevData, placements.map(({ placement }) => placement));
      if (!(await saveRelocation("Copying comment...", "Couldn't copy the comment. Please try again.", copyPayload))) return;

      let toastId;

      const linkElements = placements.map(({ dest, placement }, idx) => {
        const { template: targetTemplate, category: targetCat, line: targetLine } = placement;
        const isNarrativeTemplate = targetTemplate?.is_narrative_template === 1;
        const catName = targetCat?.prompt !== null && targetCat?.prompt !== "" ? targetCat.prompt : (targetCat?.name || dest.categoryName || "Untitled");
        const lineName = targetLine?.prompt !== null && targetLine?.prompt !== "" ? targetLine.prompt : (targetLine?.name || dest.lineName || "");
        const label = lineName ? `${catName}/${lineName}` : catName;

        return (
          <React.Fragment key={idx}>
            {idx > 0 && ", "}
            <span
              style={{ fontWeight: 700, textDecoration: "underline", cursor: "pointer", color: "#065F46" }}
              onClick={() => {
                if (toastId) toast.dismiss(toastId);
                if (targetLine) {
                  navigate(
                    `/inspection/${encodeURIComponent(catName)}/${encodeURIComponent(lineName)}`,
                    {
                      state: {
                        line: targetLine,
                        category: targetCat,
                        category_name: catName,
                        template_id: targetTemplate.template_id,
                        category_id: targetCat.id,
                        category_uuid: targetCat.uuid,
                        line_uuid: targetLine.uuid,
                        template_guid: targetTemplate?.template_guid,
                        parent_uuid: targetCat?.parent_uuid,
                        isNarrative: isNarrativeTemplate,
                        clickedFrom: MOVE_COPY_TOAST_NAV_SOURCE,
                        target: "comment",
                      },
                    }
                  );
                  dispatch(activateLines(targetLine.uuid));
                } else if (targetCat) {
                  navigate(
                    `/inspection/${encodeURIComponent(catName)}`,
                    {
                      state: {
                        category: targetCat,
                        category_name: catName,
                        template_id: targetTemplate.template_id,
                        category_id: targetCat.id,
                        category_uuid: targetCat.uuid,
                        parent_uuid: targetCat?.parent_uuid,
                        isNarrative: isNarrativeTemplate,
                        clickedFrom: MOVE_COPY_TOAST_NAV_SOURCE,
                      },
                    }
                  );
                }
              }}
            >
              {label}
            </span>
          </React.Fragment>
        );
      });

      toastId = toast.custom(
        (t) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "14px",
              backgroundColor: "#E6F7EC",
              border: "1px solid #A2E6C6",
              borderRadius: "10px",
              padding: "10px 16px",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
              color: "#065F46",
              fontSize: "14px",
              fontFamily: '"Source Sans Pro", "Open Sans", sans-serif',
              maxWidth: "90vw",
              opacity: t.visible ? 1 : 0,
              transition: "opacity 200ms ease-in-out",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <CheckCircleIcon style={{ color: "#0B8A46", fontSize: "20px" }} />
              <span>
                Comment copied to {linkElements}
              </span>
            </div>
            <CloseIcon
              style={{ fontSize: "18px", color: "#4B5563", cursor: "pointer" }}
              onClick={() => toast.dismiss(t.id)}
            />
          </div>
        ),
        {
          position: "top-center",
          duration: 8000,
        }
      );
    }
  };

  const handleDeleteFromMenu = (event) => {
    handleCloseOptionsMenu(event);
    setShowDeleteModal(true);
  };

  const dispatch = useDispatch();
  const store = useStore();
  const storeData = useSelector((state) => state.CommonReducer);
  const isMobile = useMediaQuery("(max-width: 900px)");
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };
  const handleClose = () => {
    setOpenDeleteMediaModal(false);
  };
  const checkComment = async (e, status) => {
    e.stopPropagation();
    e.preventDefault();
    setCommentSelected(status);
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
    let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item.id === categoryId);
    let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;
    let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid === uuid);
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].is_expanded = status ? 1 : 0;
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
    let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
    UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
  };
  const baseUrl = origin();
  let sessionAPIKey = sessionStorage.getItem("CK");
  let sessionSecretKey = sessionStorage.getItem("SK");
  useEffect(() => {
    window.openDropdown = async (inputId, event, dropdowns, commentUUId, listGuid) => {
      event.stopPropagation();
      event.preventDefault();
      const input = document.getElementById(inputId);
      let response;
      if (listGuid && listGuid !== "undefined") {
        try {
          response = await axios.get(`${baseUrl}get-lists?guid=${listGuid}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
              "api-key": `${Base64.decode(sessionAPIKey)}`,
              platform: "web",
              "api-platform": "WRW",
            }
          });
        } catch (e) { console.log(e) }
      }
      if (input) {
        setNewDropdownList(response?.data?.data?.options || dropdowns || []);
        setSelectedCommentId(commentUUId)
        setAnchorEl(input);
      }
    };
  }, [commentText, summaryText, comment_dropdowns, summary_comment_dropdowns])

  let commentDropElements = document.querySelectorAll(".comment-cl-detail-dropdown");
  commentDropElements?.forEach((element) => {
    if (element !== null && element !== undefined) {
      const commentUUId = element.getAttribute("comment_uuid");
      const dropdownUUId = element.getAttribute("id");
      element.onclick = (event) => {
        event.stopPropagation();
      };
      element.onchange = async (event) => {
        const selectedValue = event.target.value;
        let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
        let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item?.id === categoryId);
        let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
        let prevData = JSON.parse(JSON.stringify(inspectionData));
        delete prevData?.report_media_library_files;
        let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid == commentUUId);
        let dropdownIndex = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex]?.comment_dropdowns?.findIndex(
          (dropdown) => dropdown.dropdown_uuid === dropdownUUId
        );
        if (dropdownIndex !== -1) {
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_dropdowns[dropdownIndex].selected_value = selectedValue;
        } else {
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_dropdowns.push({
            dropdown_uuid: dropdownUUId,
            selected_value: selectedValue,
          });
        }
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
        let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
        UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
      };
    }
  });

  let summaryDropElements = document.querySelectorAll(".summary-cl-detail-dropdown");
  summaryDropElements?.forEach((element) => {
    if (element !== null && element !== undefined) {
      const commentUUId = element.getAttribute("comment_uuid");
      const dropdownUUId = element.getAttribute("id");
      element.onclick = (event) => {
        event.stopPropagation();
      };
      element.onblur = async (event) => {
        const selectedValue = event.target.value;
        let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
        let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item?.id === categoryId);
        let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
        let prevData = JSON.parse(JSON.stringify(inspectionData));
        delete prevData?.report_media_library_files;
        let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid === commentUUId);
        let dropdownIndex = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex]?.summary_comment_dropdowns?.findIndex(
          (dropdown) => dropdown.dropdown_uuid === dropdownUUId
        );
        if (dropdownIndex !== -1) {
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].summary_comment_dropdowns[dropdownIndex].selected_value = selectedValue;
        } else {
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].summary_comment_dropdowns.push({
            dropdown_uuid: dropdownUUId,
            selected_value: selectedValue,
          });
        }
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
        let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
        UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
      };
    }
  });

  let commentInputElements = document.querySelectorAll(".comment-input-box");
  commentInputElements?.forEach((element) => {
    if (element !== null && element !== undefined) {
      const commentUUId = element.getAttribute("comment_uuid");
      element.onclick = (event) => {
        event.stopPropagation();
      };
      element.onblur = async (event) => {
        let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
        let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item.id === categoryId);
        let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
        let prevData = JSON.parse(JSON.stringify(inspectionData));
        delete prevData?.report_media_library_files;
        let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid == commentUUId);
        const targetId = event.target.id;
        const newValue = event.target.value;
        let commentText = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_text;
        const textboxPattern = new RegExp(`\\[textbox id:${targetId};(.*?)]`, 'g');
        commentText = commentText.replace(textboxPattern, (match, content) => {
          if (/value:.*?;?/.test(content)) {
            return match.replace(/value:([\s\S]*?);(?=\s*\])/i, `value:${newValue};`);
          } else {
            return match.replace(/\]$/, ` value:${newValue}; ]`);
          }
        });
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_text = commentText;
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
        let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
        UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
      }
    }
  });

  let summaryInputElements = document.querySelectorAll(".summary-input-box");
  summaryInputElements?.forEach((element) => {
    if (element !== null && element !== undefined) {
      const commentUUId = element.getAttribute("comment_uuid");
      element.onclick = (event) => {
        event.stopPropagation();
      };
      element.onblur = async (event) => {
        let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
        let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item.id === categoryId);
        let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
        let prevData = JSON.parse(JSON.stringify(inspectionData));
        delete prevData?.report_media_library_files;
        let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid === commentUUId);
        const targetId = event.target.id;
        const newValue = event.target.value;
        let commentText = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].summary_comment_text;
        const textboxPattern = new RegExp(`\\[textbox id:${targetId};(.*?)]`, 'g');
        commentText = commentText.replace(textboxPattern, (match, content) => {
          if (/value:.*?;?/.test(content)) {
            return match.replace(/value:([\s\S]*?);(?=\s*\])/i, `value:${newValue};`);
          } else {
            return match.replace(/\]$/, ` value:${newValue}; ]`);
          }
        });
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].summary_comment_text = commentText;
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
        let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
        UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
      }
    }
  });

  const handleChangeDropdown = async (event) => {
    const selectedValue = event;
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
    let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item?.id === categoryId);
    let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;
    let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid === selectedCommentId);
    let dropdownIndex;
    if (anchorEl.name === 'comment') {
      dropdownIndex = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex]?.comment_dropdowns?.findIndex(
        (dropdown) => dropdown.dropdown_uuid === anchorEl?.id
      );
      if (dropdownIndex !== -1) {
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_dropdowns[dropdownIndex].selected_value = selectedValue;
      }
    } else {
      dropdownIndex = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex]?.summary_comment_dropdowns?.findIndex(
        (dropdown) => dropdown.dropdown_uuid === anchorEl?.id
      );
      if (dropdownIndex !== -1) {
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].summary_comment_dropdowns[dropdownIndex].selected_value = selectedValue;
      }
    }
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
    let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
    UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    setAnchorEl(null);
  };

  const deleteClComment = async () => {
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex((item) => item.template_id === templateId);
    let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((item) => item.id === categoryId);
    let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;
    let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((item) => item.uuid == uuid);
    markCommentDeleted(prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex], await GetUTCTime());
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].is_selected_updated_at = await GetUTCTime();
    prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].description = "";
    let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'CommentSelection');
    setLineData(prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]);
    await UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    setShowDeleteModal(false);
  };

  useEffect(() => {
    if (storeData.inspectionData) {
      setInspectionData(storeData.inspectionData?.data);
    }
  }, [storeData.inspectionData]);

  useEffect(() => { }, [comment_text, summary_comment_text])

  const handleCloseCLEditModal = () => {
    setCommentTitle(title);
    setCommentTag(tags);
    setSummaryTag(summaries);
    setCommentText({ innerHTML: "", dropdownList: [] });
    setSummaryText({ innerHTML: "", dropdownList: [] });
    setShowEditCLModal(false);
  };

  const handleOpenEditModal = (uuid) => {
    const commentData = lineData?.comments.find(obj => obj?.uuid === uuid);
    const dropdownPattern = /\[dropdown ([a-f0-9-]+)\]/g;
    const updatedCommentText = commentData?.comment_text?.replace(dropdownPattern, (match, id) => {
      return `<span contenteditable="false">${match}</span>`;
    });
    const updatedSummaryText = commentData?.summary_comment_text?.replace(dropdownPattern, (match, id) => {
      return `<span contenteditable="false">${match}</span>`;
    });
    setCommentTitle(commentData?.title);
    setCommentTag(commentData?.tags);
    setSummaryTag(commentData?.summaries);
    setCommentText({ innerHTML: updatedCommentText, dropdownList: commentData?.comment_dropdowns, });
    setSummaryText({ innerHTML: updatedSummaryText || "", dropdownList: commentData?.summary_comment_dropdowns, });
    setCommentDropDowns(commentData?.comment_dropdowns);
    setSummaryDropDowns(commentData?.summary_comment_dropdowns);
    setShowEditCLModal(true);
  }

  let { photoCount, videoCount } =
    comment_input_controls?.reduce(
      (acc, item) => {
        // Only media controls hold an array; other controls (e.g. rating) can carry an object in `data`.
        if (!Array.isArray(item.data)) return acc;
        item.data.forEach((file) => {
          if (file.filetype === "image") {
            acc.photoCount++;
          } else if (file.filetype === "video") {
            acc.videoCount++;
          }
        });
        return acc;
      },
      { photoCount: 0, videoCount: 0 }
    ) || { photoCount: 0, videoCount: 0 };

  const isAnyModalOpen = () => {
    return document.querySelector('.MuiModal-root, .modal, [role="dialog"], [aria-modal="true"]') !== null;
  };

  const handleDeleteCommentMedia = async () => {
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex((itm) => itm.template_id === templateId);
    let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.id === categoryId);
    let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
    if ([templateIndex, categoryIndex, lineIndex].some((idx) => idx === undefined || idx < 0)) {
      setOpenDeleteMediaModal(false);
      return;
    }
    let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex(
      (itm) => itm.uuid === commentUuid
    );
    let mediaIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments[
      commentIndex
    ]?.comment_input_controls?.findIndex((itm) => itm.type === "Media");
    let imageIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments[commentIndex]?.comment_input_controls[
      mediaIndex
    ]?.data.findIndex((img) => img.id === activeDeleteMedia?.id);
    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;
    if (mediaIndex !== -1) {
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls[mediaIndex].updated_at = await GetUTCTime();
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls[mediaIndex].data[imageIndex].is_deleted = 1;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls[mediaIndex].data[imageIndex].updated_at = await GetUTCTime();
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls[mediaIndex].data[imageIndex].description = "";
      let filteredObject = cleanPayloadOnCommentICMediaLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, mediaIndex, imageIndex);
      UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    }
    setOpenDeleteMediaModal(false);
  }

  return (
    <>
      {!showEditCLModal ? <Popover open={Boolean(anchorEl) && !isAnyModalOpen()} anchorEl={anchorEl} anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }} sx={{ zIndex: 999999999, }} slotProps={{ paper: { sx: { boxShadow: "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)" } } }} onClose={() => setAnchorEl(null)}>
        <ClickAwayListener onClickAway={() => setAnchorEl(null)} >
          <Paper style={{ width: "184px", maxHeight: "400px", overflowX: "scroll", textOverflow: "ellipsis", }}>
            {newDropdownList?.map((e, index) => (
              <MenuItem key={index} sx={{
                fontSize: "14px",
                padding: "10px 4px 0px 8px",
                fontFamily: "Open Sans",
                letterSpacing: 0,
                overflow: "hidden",         // Ensure overflow is hidden
                whiteSpace: "nowrap",       // Prevent text wrapping
                textOverflow: "ellipsis",   // Apply ellipsis effect
                maxWidth: "220px",
                display: "block"
              }}
                onClick={() => handleChangeDropdown(e, e?.target?.id)}
              >{e}</MenuItem>
            ))}
          </Paper>
        </ClickAwayListener>
      </Popover > : null}
      <EditClCommentModal
        lineData={lineData}
        templateId={templateId}
        categoryId={categoryId}
        lineUuid={lineUuid}
        setShowEditCLModal={setShowEditCLModal}
        showEditCLModal={showEditCLModal}
        commentTitle={commentTitle}
        commentTag={commentTag}
        setCommentTag={setCommentTag}
        summaryTag={summaryTag}
        setSummaryTag={setSummaryTag}
        commentText={commentText}
        setCommentText={setCommentText}
        summaryText={summaryText}
        setSummaryText={setSummaryText}
        summaryDropDowns={summaryDropDowns}
        setSummaryDropDowns={setSummaryDropDowns}
        commentDropDowns={commentDropDowns}
        setCommentDropDowns={setCommentDropDowns}
        commentUuid={uuid}
        summaries={summaries}
        categoryUuid={categoryUuid}
        commentIndex={commentIndex}
        is_selected={is_selected}
        tags={tags}
        inspectionData={inspectionData}
        categoryName={categoryName}
        setShowDeleteModal={setShowDeleteModal}
        handleCloseCLEditModal={handleCloseCLEditModal}
        setCommentTitle={setCommentTitle}
        commentData={lineData?.comments.find(obj => obj?.uuid === uuid)}
      />
      <DeleteCommentDialog
        open={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        title={title ? `Delete '${title}'?` : "Delete?"}
        contentText={"Are you sure you want to delete this comment from the report?"}
        cancelBtnTitle={"Cancel"}
        cancelBtnAction={handleCloseDeleteModal}
        submitBtnTitle={"Delete"}
        submitBtnAction={deleteClComment}
      />
      <DeleteMediaModal
        open={openDeleteMediaModal}
        handleClose={handleClose}
        cancelBtnAction={handleClose}
        submitBtnAction={handleClose}
        handleDeleteRMLMedia={handleDeleteCommentMedia}
      />
      <MoveCopyCommentModal
        open={showMoveCopyModal}
        handleClose={() => setShowMoveCopyModal(false)}
        mode={moveCopyMode}
        currentCategoryId={categoryId}
        currentCategoryUuid={categoryUuid}
        currentLineUuid={lineUuid}
        templateId={templateId}
        onConfirm={handleMoveOrCopyConfirm}
      />
      <div style={{ padding: "17px 26px 17px 26px" }}>
        <Accordion expanded={is_expanded} sx={{ border: isDragging ? "3px solid rgba(66, 130, 226, 0.25) !important" : "1px solid #DDD !important", boxShadow: isDragging ? "0px 4px 18px 0px rgba(0, 0, 0, 0.25) !important" : "none" }} >
          <AccordionSummary
            onClick={(e) => checkComment(e, !is_expanded)}
            sx={{
              padding: "0px 12px",
              "& .MuiAccordionSummary-content": {
                margin: 0,
                flexDirection: "column",
              },
              "&.Mui-expanded": {
                minHeight: "unset",
              }
            }}
          >
            {/* Fixed Header Row */}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ height: "48px", borderBottom: "1px solid #D8D8D8" }}
            >
              <Grid item>
                <div style={{ cursor: "grab" }}>
                  <span ref={dragHandleRef} {...dragListeners}>
                    <DragIndicatorIcon fontSize="small" />
                  </span>
                </div>
              </Grid>
              <Grid item>
                <Grid container alignItems="center">
                  <IconButton size="small" onClick={(e) => {
                    e.stopPropagation();
                    handleOpenEditModal(uuid);
                  }}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton size="small" onClick={(e) => checkComment(e, !is_expanded)}>
                    {is_expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                  <IconButton
                    size="small"
                    aria-label="comment options menu"
                    id={`comment_options_btn_${uuid}`}
                    onClick={handleOpenOptionsMenu}
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                  <Menu
                    id={`comment_options_menu_${uuid}`}
                    anchorEl={optionsAnchorEl}
                    open={Boolean(optionsAnchorEl)}
                    onClose={handleCloseOptionsMenu}
                    onClick={(e) => e.stopPropagation()}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    sx={{
                      "& .MuiPaper-root": {
                        boxShadow: "rgba(0, 0, 0, 0.01) 0px 4px 4px",
                        backgroundColor: "#ffffff",
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        padding: "8px 0",
                        width: "240px",
                      },
                    }}
                  >
                    <MenuItem onClick={handleToggleExpandFromMenu} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      {is_expanded ? (
                        <MdOutlineUnfoldMore style={{ fontSize: "20px", color: "#555555" }} />
                      ) : (
                        <MdOutlineUnfoldMore style={{ fontSize: "20px", color: "#555555" }} />
                      )}
                      <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                        {is_expanded ? "Collapse comment" : "Expand comment"}
                      </span>
                    </MenuItem>
                    <MenuItem onClick={handleEditFromMenu} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <MdOutlineModeEditOutline style={{ fontSize: "20px", color: "#555555" }} />
                      <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                        Edit comment
                      </span>
                    </MenuItem>
                    <MenuItem onClick={handleDuplicateFromMenu} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <LibraryAddOutlinedIcon style={{ fontSize: "20px", color: "#555555" }} />
                      <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                        Duplicate comment
                      </span>
                    </MenuItem>
                    <MenuItem onClick={handleCopyTextFromMenu} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <ContentCopyIcon style={{ fontSize: "20px", color: "#555555" }} />
                      <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                        Copy comment text
                      </span>
                    </MenuItem>
                    <MenuItem onClick={handleOpenMoveModal} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <ExitToAppOutlinedIcon style={{ fontSize: "20px", color: "#555555" }} />
                      <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                        Move to...
                      </span>
                    </MenuItem>
                    <MenuItem onClick={handleOpenCopyModal} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <MdOutlineFolderCopy style={{ fontSize: "20px", color: "#555555" }} />
                      <span style={{ fontWeight: "400 !important", fontSize: "14px !important", color: "#3b3b3b !important" }}>
                        Copy to...
                      </span>
                    </MenuItem>
                    <Divider sx={{ margin: "8px 0" }} />
                    <MenuItem
                      onClick={handleDeleteFromMenu}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        fontWeight: "400 !important",
                        fontSize: "14px !important",
                      }}
                    >
                      <RiDeleteBin6Line style={{ fontSize: "20px", color: "#D53D3D" }} />
                      <span style={{ color: "#D53D3D" }}>Delete comment</span>
                    </MenuItem>
                  </Menu>
                </Grid>
              </Grid>
            </Grid>
            {/* Variable Height Content */}
            <Grid container mt={1} px={1} onClick={(e) => e.stopPropagation()}>
              {title && title.trim() !== "" && (
                <Grid item xs={12} mb={1} display={"flex"} alignItems={"start"}>
                  <CollapsibleComment
                    expanded={!!is_expanded}
                    className="narrative_comment_title"
                    id={`comment_title_${commentIndex}`}
                    fontSize="18px"
                    maxLines={3}
                    threshold={3}
                  >
                    {title}
                  </CollapsibleComment>
                </Grid>
              )}
              <CollapsibleComment
                expanded={!!is_expanded}
                className={is_expanded ? "comment_detail_cl" : "comment_description_cl"}
                id="comment_description_cl"
                fontSize="16px"
                html={comment_text !== null ? replacePlaceholdersWithDropdowns(comment_text?.replace(/<button[^>]*?>✎<\/button>/g, ""), comment_dropdowns, "comment", uuid) : null}
              />
            </Grid>
            {!is_expanded && <Grid item xs={12} container sx={{ ml: 1, mb: 2 }}>
              <Box display="flex" alignItems="center">
                <Box>
                  <div className="cl_summary_rating_section">
                    {summaries?.length !== 0
                      ? summaries?.map((element) => (
                        <div className="cl_summary_rating_square_container">
                          <div
                            className="rating_square"
                            style={{ background: `${element?.color}`, padding: "4px" }}
                          ></div>
                          <div className="cl_rating_name_text">{element?.name}</div>
                        </div>
                      ))
                      : null}
                    <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: "#979797 !important" }} />
                    <Box display="flex" alignItems="center" sx={{ gap: "8px" }}><PhotoSizeSelectActualIcon sx={{ fontSize: "17px" }} /> <Typography className="photo_text">{photoCount} Photos</Typography><VideocamIcon sx={{ fontSize: "19px" }} /><Typography className="photo_text">{videoCount} Videos</Typography>  </Box>
                  </div>
                </Box>
              </Box>
            </Grid>}
          </AccordionSummary>
          <AccordionDetails sx={{ pt: "0px !important", pl: storeData?.reportSideBarActive ? "16px !important" : isMobile ? "16px !important" : "42px !important" }}>
            <Grid container>
              <NarrativeSummary
                summary={summary_comment_text}
                summaries={summaries}
                templateId={templateId}
                categoryId={categoryId}
                lineUuid={lineUuid}
                commentUuid={uuid}
                commentIndex={commentIndex}
                summary_comment_dropdowns={summary_comment_dropdowns}
                inspectionData={inspectionData}
                uuid={uuid}
              />
            </Grid>
            <Grid container mt={2}>
              <NarrativeMedia
                setSelectedImages={setSelectedImages}
                toggle={toggle}
                setSelectedMediaFiles={setSelectedMediaFiles}
                selectedMediaFiles={selectedMediaFiles}
                data={comment_input_controls?.find((data) => data.type === "Media")}
                title="Add Media"
                action="comment"
                templateId={templateId}
                categoryId={categoryId}
                lineUuid={lineUuid}
                setSelectedComment={setCommentSelected}
                commentUuid={uuid}
                commentIndex={commentIndex}
                categoryUuid={categoryUuid}
                setRefresh={setRefresh}
                isNarrative={isNarrative}
                addCommentFromLine={addCommentFromLine}
                setOpenDeleteMediaModal={setOpenDeleteMediaModal}
                setActiveDeleteMedia={setActiveDeleteMedia}
                setCommentUuid={setCommentUuid}
              />
            </Grid>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

export default CommentDetailsNarrative;